import create from 'zustand';
import axios from 'axios';
import Cookies from 'js-cookie';

// En producción usa la URL del API, en desarrollo usa localhost
const API_BASE_URL = process.env.REACT_APP_API_URL 
  ? `${process.env.REACT_APP_API_URL}/api/v1`
  : 'http://localhost:5001/api/v1';

const api = axios.create({
  baseURL: API_BASE_URL
});

api.interceptors.request.use((config) => {
  const token = Cookies.get('authToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

const useAuthStore = create((set) => ({
  user: null,
  token: Cookies.get('authToken') || null,
  loading: false,
  login: async (email, password) => {
    set({ loading: true });
    try {
      const response = await api.post('/auth/login', { email, password });
      Cookies.set('authToken', response.data.token);
      set({ user: response.data.user, token: response.data.token, loading: false });
      return response.data;
    } catch (error) {
      set({ loading: false });
      throw error;
    }
  },
  logout: () => {
    Cookies.remove('authToken');
    set({ user: null, token: null });
  },
  // Theme and Language
  darkMode: false,
  language: 'es', // 'es' | 'en'
  toggleTheme: () => set((state) => {
    const newMode = !state.darkMode;
    if (newMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
    return { darkMode: newMode };
  }),
  toggleLanguage: () => set((state) => ({ language: state.language === 'es' ? 'en' : 'es' }))
}));

export { api, useAuthStore };
